<div [ngClass]="{ wrapper: !label, 'wrapper-with-label': label }">
    <ng-container *ngIf="isShown">
        <p *ngIf="label">{{ label }}</p>
        <ngb-progressbar type="info" [striped]="true" [value]="100" [animated]="true" data-uit="loader"></ngb-progressbar>
    </ng-container>
</div>
